<template>
  <div id="app">
    <v-app>
      <AppBar />
      <Drawer />

      <v-main>
        <router-view />
      </v-main>

      <Footer />
      <ScrollToTop />
    </v-app>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    AppBar: () => import("./components/layout/AppBar"),
    Drawer: () => import("./components/layout/Drawer"),
    Footer: () => import("./components/layout/Footer"),
    ScrollToTop: () => import("./components/layout/ScrollToTop"),
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Aller-Display";
  src: url("./assets/fonts/Aller-Display.ttf.woff") format("woff"),
    url("./assets/fonts/Aller-Display.ttf.svg#Aller-Display") format("svg"),
    url("./assets/fonts/Aller-Display.ttf.eot"),
    url("./assets/fonts/Aller-Display.ttf.eot?#iefix")
      format("embedded-opentype");
  font-weight: normal;
  font-style: normal;
}
</style>
